import React, { Component } from 'react';

import { Button, Image } from 'react-bootstrap';

class Card extends Component {

	renderLogo() {
		let imageUrl = this.props.domain ? ("https://www.webfinery.com/static/media/" + this.props.domain + ".png") : "placeholder-logo.png";
		return <div><Image className="techLogo" src={imageUrl} height="64" width="64" /></div>
	}

  render() {
    return (
      <div className="card">
      	<h6>{this.props.name}</h6>
      	{this.renderLogo()}
      	<Button bsSize="sm" bsStyle="success" onClick={this.props.onDownloadRequest}>Get it</Button>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/content/Card.js